module.exports = __webpack_public_path__ + "img/1-4.52566402.svg";